import { render } from "./AccountOnboardingProfilePicturePage.vue?vue&type=template&id=0c96c35c&ts=true"
import script from "./AccountOnboardingProfilePicturePage.vue?vue&type=script&lang=ts"
export * from "./AccountOnboardingProfilePicturePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__